import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { AppConstants } from '../../../../config/appConstants';
import { PaymentOption } from '../../../../model/common.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'option-content',
    templateUrl: 'option-content.component.html',
    imports: [TranslateModule],
})
export class OptionContentComponent {
    usedOption = input<PaymentOption>();
    isUSLabel = input<boolean>(false);
    prepaidCardsAndEchecks = AppConstants.PREPAIDCARDSAndECHECKS;
}
